import { useState } from 'react';
import { fieldReportPhotoHref } from '../../services/intelPacketApi';

/**
 * Photo URL for a field-report JPEG.
 *
 * The dock <img> must use an HTTP URL, not a blob. Blob URLs were revoked or
 * lost to `img { height: auto }` after onLoad, which left the well empty with
 * 1536×2048 still written on the overlay. The map popup kept working because
 * it sizes with maxHeight and never height:100%.
 */
export function useFieldReportPhoto(
  reportId: string | undefined,
  variant: 'original' | 'annotated',
  enabled = true,
): { src: string | null; error: string | null; loading: boolean; retry: () => void } {
  const [tick, setTick] = useState(0);
  const src = enabled && reportId ? fieldReportPhotoHref(reportId, variant, tick || undefined) : null;
  return {
    src,
    error: null,
    loading: false,
    retry: () => setTick((n) => n + 1),
  };
}
